module.exports = __webpack_public_path__ + "img/qianpai.ac020189.png";